/**
 * SaveSetButton — quiet toolbar entry into SaveSetDialog, disabled with a
 * reason while the tab holds nothing worth saving.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { Save } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';
import { Tooltip } from '@/components/ui/Tooltip';

export interface SaveSetButtonProps {
  disabledReason?: string;
  onClick: () => void;
}

const SaveSetButton: FC<SaveSetButtonProps> = ({ disabledReason, onClick }) => (
  <Tooltip
    content={disabledReason ?? 'Save this tab’s work as a reusable library set.'}
    side="bottom"
  >
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={Boolean(disabledReason)}
      className="h-8 px-2.5 text-xs"
    >
      <Save className="mr-1 h-3.5 w-3.5" aria-hidden />
      Save as set…
    </Button>
  </Tooltip>
);

export default SaveSetButton;
